import React from 'react';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { Empty, LayoutSidebar, SectionHeader, TipCalcPoolsSidebar } from 'components';
import { PoolItem } from 'components/Calculator';
import { MPContent } from 'screens/MakePayment/styles';
import { selectCalculatorPaymentSet, selectCalculatorResults } from 'store/TipCalculator';
import { calculateTipCalculatorPoolTotals } from 'utils';

interface IPoolsProps {
  onBack: () => void;
  pageHeaderContent: React.ReactNode;
}

const Pools = ({ onBack, pageHeaderContent }: IPoolsProps) => {
  const tipCalcResults = useSelector(selectCalculatorResults());
  const paymentSetDate = useSelector(selectCalculatorPaymentSet())?.date;

  return (
    <LayoutSidebar
      content={
        <>
          {pageHeaderContent}
          <MPContent data-cy="pools-list">
            <SectionHeader data-cy="pools-header" title="Pools" />
            {!tipCalcResults?.length ? (
              <Empty container containerHeight={250} icon="Group" message="No pools found" />
            ) : (
              tipCalcResults.map((result) => <PoolItem key={`pool_item_${result.segmentId}`} calculatorResult={result} businessDay={paymentSetDate} />)
            )}
          </MPContent>
        </>
      }
      sidebar={<TipCalcPoolsSidebar businessDate={dayjs(paymentSetDate)} totals={calculateTipCalculatorPoolTotals(tipCalcResults ?? [])} onBack={onBack} />}
    />
  );
};

export default Pools;
